import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

export const FORM_FIELD = {
  IMAGE: {
    name: 'image',
    label: 'Image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['2000x240'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Write a title...',
    rules: [{ required: true, message: 'Title is required' }],
  },
  BUTTON_TEXT: {
    name: 'buttonText',
    label: 'Button text:',
    placeholder: 'Write the text for the button...',
    rules: [{ required: true, message: 'Button text is required' }],
  },
  BUTTON_URL: {
    entityName: 'page',
    urlName: 'url',
    label: 'Button URL:',
    placeholder: 'Enter the URL or start typing a page name...',
    rules: [{ required: true, message: 'URL or page is required' }],
    serialize: utils.entityOrUrlFieldSerialize,
  },
};
